import styled from 'styled-components/macro';

// width: 100%;
const TableBody = styled('tbody')``;

export default TableBody;
